export function getTableHeaders(id: string): string[] {
  const thElements = document.querySelectorAll(`#${id} thead th:not(.action-header)`);
  const headers: string[] = [];

  thElements.forEach((th: any) => {
    const text = th.innerText.trim();
    const style = window.getComputedStyle(th);

    const isVisible =
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      th.offsetParent !== null;

    if (text.trim() !== '' && isVisible) {
      headers.push(text);
    }
  });

  return headers;
}
